import { connect } from 'react-redux';

import * as checklistSelectors from '../../../../../selectors/checklist/checklistSelectors';
import { getUserWeddingDate } from '../../../../../selectors/user/userSelectors';

import ChecklistTaskList from './PrintChecklistTaskList';

const mapStateToProps = state => ({
  checklistTasksGroups: checklistSelectors.getChecklistTaskGroups(state),
  checklistTasks: checklistSelectors.getChecklistTasks(state),
  filteredChecklistTaskGroups: checklistSelectors.getChecklistTaskGroups(state),
  filtersActive: Boolean(checklistSelectors.getTaskFilters(state).length),
  weddingDate: getUserWeddingDate(state),
});

export default connect(mapStateToProps, null)(ChecklistTaskList);



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/PrintChecklist/PrintChecklistTaskList/index.js